"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

require("../style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Td = function Td(_ref) {
  var isMonospace = _ref.isMonospace,
      children = _ref.children;
  return _react["default"].createElement("td", {
    className: isMonospace ? 'info-table-monospace' : null
  }, children);
};

Td.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].element, _propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].arrayOf(_propTypes["default"].element)]),
  isMonospace: _propTypes["default"].bool
};
Td.defaultProps = {
  isMonospace: false,
  children: null
};
var _default = Td;
exports["default"] = _default;